module.exports = __webpack_public_path__ + "static/media/CS_logo.c3cd38a9.png";